import { withNamespaces } from "react-i18next"
import { RiMapPinLine } from "react-icons/ri"
import { Button, Modal, ModalBody, ModalHeader, Table } from "reactstrap"
import ProducerMapModal from "./ProducerMapModal"
import { useState } from "react"

const CommodityModal = ({ isOpen, toggle, commodity }) => {
    const [selectedProducer, setSelectedProducer] = useState();

    return (
        <>
            <Modal
                isOpen={isOpen}
                toggle={toggle}
                size="lg"
            >
                <ModalHeader
                    toggle={toggle}
                >
                    Producers for {commodity?.description}
                </ModalHeader>

                <ModalBody>
                    <Table bordered hover responsive>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Country</th>
                                <th>Map</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(commodity?.producers || []).map((p, idx) => (
                                <tr key={idx}>
                                    <td>{idx + 1}</td>
                                    <td>{p.name}</td>
                                    <td>{p.country}</td>
                                    <td>
                                        {p?.geometryGeojson ? (
                                            <Button
                                                color="info"
                                                size="sm"
                                                onClick={() => setSelectedProducer(p)}
                                            >
                                                <RiMapPinLine />
                                            </Button>
                                        ) : (
                                            <Button 
                                                color="secondary" 
                                                size="sm" 
                                                disabled 
                                                title={'No geolocation data available'}
                                            >
                                                <i className="ri-map-pin-line"></i> N/A
                                            </Button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>

            <ProducerMapModal 
                isOpen={!!selectedProducer}
                toggle={() => setSelectedProducer(null)}
                producer={selectedProducer}
            />
        </>
    )
}

export default withNamespaces()(
    CommodityModal
)